import React, { useState } from "react";
import Modal from '@material-ui/core/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons'
import CustomeInput from '../components/custom-input';
import { setUserMetaData } from "../helpers/firebase";
import { getUser } from "../helpers/auth";

const JobTitleModal = ({open, onClose, userMetaData, ...props}) => {
    const user = getUser();
    const [newJobTitle, setNewJobTitle] = useState('');

    const handleSet = async () => {
        userMetaData.jobTitle = newJobTitle;
        await setUserMetaData(user.uid, userMetaData);
        onClose();
    }

    return (
        <Modal 
            open={open || false}
            onClose={onClose || function () {}}
            {...props}
        >
            <div className="c_modal ps_modal">
                <div className="sub_cmodal">
                    <div className="modal_header">
                        <div className="title">
                            Job title
                        </div>
                        <div className="btn_close" onClick={() => onClose()}>
                            <FontAwesomeIcon className="fa_icon" icon={faTimes} />
                        </div>
                    </div>
                    <div className="modal_content">
                        <div className="ct_cinputs">
                            <CustomeInput 
                                autoFocus={true}
                                icon={faUser}
                                title="Job title"
                                placeholder="Write your job title"
                                onChange={value => setNewJobTitle(value)}
                            />
                        </div>
                        <button className="set_m_btn btn" onClick={() => handleSet()}>
                            Set
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    ) 
}

export default JobTitleModal;